import Vue from "vue";
import Router from "vue-router";
import store from './store/'

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: "/",
      component: () => import("./layouts/main/MainRekomAdmin.vue"),
      meta: {
        requiresAuth: true
      },
      children: [
        // =============================================================================
        // Venue Portal
        // =============================================================================
        {
          path: "/vp/dashboard",
          name: "vp-dashboard",
          component: () => import("./views/modules/vp/dashboard/DashboardOld.vue"),
          meta: {
            requiresAuth: true,
            permission: "vp.vp.dashboard.show",
            menu: 0
          }
        },
        {
          path: "/vp/lists",
          name: "lists",
          component: () => import("./views/modules/vp/lists/ListsTabs.vue"),
          meta: {
            requiresAuth: true,
            permission: "vp.vp.lists.show",
            menu: 0
          }
        },


        {
          path: "/vp/tasks",
          name: "venue-tasks",
          component: () => import("./views/modules/vp/venueTasks/VenueTasks.vue"),
          meta: {
            requiresAuth: true,
            permission: "vp.vp.venuetasks.show",
            menu: 0
          }
        },
        {
          path: "/vp/todos",
          name: "personal-todos",
          component: () => import("./views/modules/vp/personalTodos/TodosMenu.vue"),
          meta: {
            requiresAuth: true,
            permission: "vp.vp.personaltodos.show",
            menu: 0
          }
        },
        {
          path: "/vp/info",
          name: "venue-info",
          component: () => import("./views/modules/vp/info/Info.vue"),
          meta: {
            requiresAuth: true,
            permission: "vp.vp.venueinfo.show",
            menu: 0
          }
        },
        {
          path: "/vp/activationplan",
          name: "activation-plan",
          component: () =>
            import("./views/modules/vp/activationPlan/ActivationPlan.vue"),
          meta: {
            requiresAuth: true,
            permission: "vp.vp.activationplan.show",
            menu: 0
          }
        },
        {
          path: "/vp/venuedrive",
          name: "venue-drive",
          component: () =>
            import("./views/modules/vp/venueDrive/VenueDrive.vue"),
          meta: {
            requiresAuth: true,
            permission: "vp.vp.venuedrive.show",
            menu: 0
          }
        },
        {
          path: "/vp/venuecampaigns",
          name: "vp-venuecampaigns",
          component: () => import("./views/modules/vp/venueCampaigns/VenueCampaignsMenu.vue"),
          meta: {
            requiresAuth: true,
            permission: "vp.vp.venuecampaigns.view",
            menu: 0
          }
        },

        {
          path: "/vp/venuecampaigns/:id",
          name: "vp-venuecampaign",
          component: () => import("./views/modules/vp/venueCampaigns/VenueCampaign.vue"),
          meta: {
            requiresAuth: true,
            permission: "vp.vp.venuecampaigns.view",
            menu: 0
          }
        },

        {
          path: "/vp/visits/visit/:surveySessionId",
          name: "visit",
          component: () => import("./views/modules/vp/lists/VenueVisits/Visit/Visit.vue"),
          meta: {
            requiresAuth: true,
            menu: 0
          }
        },
        {
          path: "/vp/lists/eodReport/:id",
          name: "eodReport",
          component: () => import("./views/modules/vp/lists/EodReports/Report/EodReport.vue"),
          meta: {
            requiresAuth: true,
            menu: 0
          }
        },

        // =============================================================================
        // Cockpit
        // =============================================================================
        {
          path: "/cp/report/:id",
          name: "cockpitReport",
          component: () => import("./views/modules/cockpit/report/Report.vue"),
          meta: {
            requiresAuth: true,
            menu: 1
          }
        },
        {
          path: "/cp/reports",
          name: "cp-reports",
          component: () => import("./views/modules/cockpit/manageReports/Reports.vue"),
          meta: {
            requiresAuth: true,
            menu: 1
          }
        },
        {
          path: "/cp/powerbitester",
          name: "powerbitester",
          component: () => import("./views/modules/cockpit/powerbiTester/PowerbiTester.vue"),
          meta: {
            requiresAuth: true,
            menu: 1
          }
        },


        // =============================================================================
        // Marcom
        // =============================================================================
        {
          path: "/marcom/marcom",
          name: "marcom",
          component: () => import("./views/modules/marcom/Marcom.vue"),
          meta: {
            requiresAuth: true,
            permission: "vp.vp.booking.show",
            menu: 0 // 2
          }
        },
        {
          path: "/marcom/guest-relations",
          name: "guest-relations",
          component: () => import("./views/modules/marcom/guestRelations/GuestRelations.vue"),
          meta: {
            requiresAuth: true,
            permission: "vp.crm.bookingoverview.show",
            menu: 4 // 2
          }
        },

        // =============================================================================
        // Campus
        // =============================================================================
        {
          path: "/campus/campus",
          name: "Campus",
          component: () => import("./views/modules/campus/CampusTabs.vue"),
          meta: {
            requiresAuth: true,
            permission: "vp.campus.show",
            menu: 2
          }
        },

        // =============================================================================
        // News
        // =============================================================================
        {
          path: '/',
          name: 'news',
          component: () => import('./views/modules/news/News.vue'),
          meta: {
            requiresAuth: true,
            menu: 3
          }
        },


        // =============================================================================
        // CRM
        // =============================================================================
        {
          path: "/crm/campaigns",
          name: "crm-campaigns",
          component: () => import("./views/modules/crm/Campaigns/MasterCampaigns.vue"),
          meta: {
            requiresAuth: true,
            permission: "vp.crm.campaigns.view",
            menu: 4
          }
        },

        {
          path: "/crm/campaigns/:id",
          name: "crm-campaign",
          component: () => import("./views/modules/crm/Campaigns/MasterCampaign.vue"),
          meta: {
            requiresAuth: true,
            permission: "vp.crm.campaigns.view",
            menu: 4
          }
        },

        {
          path: "/crm/guests",
          name: "crm-guest-profiles",
          component: () => import("./views/modules/crm/GuestProfiles/GuestOverview.vue"),
          meta: {
            requiresAuth: true,
            permission: "vp.crm.guestprofiles.view",
            menu: 4
          }
        },
        {
          path: "/crm/guest/:id",
          name: "crm-guest-profile",
          component: () => import("./views/modules/crm/GuestProfiles/profile/GuestProfile.vue"),
          meta: {
            requiresAuth: true,
            permission: "vp.crm.guestprofiles.view",
            menu: 4
          }
        },
        {
          path: "/crm/automations/email-templates",
          name: "crm-automation-email-templates",
          component: () => import("./views/modules/crm/Automations/EmailTemplates/EmailTemplates.vue"),
          meta: {
            requiresAuth: true,
            permission: "vp.crm.automations.view",
            menu: 4
          }
        },
        {
          path: "/crm/automations/email-templates/:id",
          name: "crm-automation-email-template",
          component: () => import("./views/modules/crm/Automations/EmailTemplates/EmailTemplate/EmailTemplate.vue"),
          meta: {
            requiresAuth: true,
            permission: "vp.crm.automations.view",
            menu: 4
          }
        },
        {
          path: "/crm/automations",
          name: "crm-automations",
          component: () => import("./views/modules/crm/Automations/Automations.vue"),
          meta: {
            requiresAuth: true,
            permission: "vp.crm.automations.view",
            menu: 4
          }
        },
        {
          path: "/crm/templates/:id",
          name: "crm-automation",
          component: () => import("./views/modules/crm/Automations/Automation/Automation.vue"),
          meta: {
            requiresAuth: true,
            permission: "vp.crm.automations.view",
            menu: 4
          }
        },

        {
          path: "/crm/dynamicforms",
          name: "crm-dynamicforms",
          component: () => import("./views/modules/crm/DynamicForms/DynamicForms.vue"),
          meta: {
            requiresAuth: true,
            permission: "vp.crm.dynamicforms.view",
            menu: 4
          }
        },
        {
          path: "/crm/dynamicforms/:id",
          name: "crm-dynamicform",
          component: () => import("./views/modules/crm/DynamicForms/DynamicForm/DynamicForm.vue"),
          meta: {
            requiresAuth: true,
            permission: "vp.crm.dynamicforms.view",
            menu: 4
          }
        },

        {
          path: "/crm/legaldocuments",
          name: "crm-legaldocuments",
          component: () => import("./views/modules/crm/LegalDocuments/LegalDocuments.vue"),
          meta: {
            requiresAuth: true,
            permission: "vp.crm.legaldocuments.view",
            menu: 4
          }
        },
        {
          path: "/crm/legaldocument/:id",
          name: "crm-legaldocument",
          component: () => import("./views/modules/crm/LegalDocuments/LegalDocument/LegalDocument.vue"),
          meta: {
            requiresAuth: true,
            permission: "vp.crm.legaldocuments.view",
            menu: 4
          }
        },
        {
          path: "/crm/legaldocument/:id/:revision",
          name: "crm-legaldocument-revision",
          component: () => import("./views/modules/crm/LegalDocuments/LegalDocument/LegalDocument.vue"),
          meta: {
            requiresAuth: true,
            permission: "vp.crm.legaldocuments.view",
            menu: 4
          }
        },


        {
          path: "/crm/engage/messenger",
          name: "crm-engage-messenger",
          component: () => import("./views/modules/crm/Engage/Messenger/Chat.vue"),
          meta: {
            requiresAuth: true,
            permission: "vp.crm.engagemessenger.view",
            menu: 4
          }
        },


        {
          path: '/crm/engage/email',
          redirect: '/crm/engage/email/inbox',
          name: 'crm-engage-email'
        },
        {
          path: "/crm/engage/email/:filter",
          component: () => import("./views/modules/crm/Engage/Email/Email.vue"),
          meta: {
            requiresAuth: true,
            permission: "vp.crm.engageemail.view",
            menu: 4,
            rule: 'editor',
            parent: 'crm-engage-email',
            no_scroll: true
          }
        },

        {
          path: "/crm/engage/configuration",
          name: "crm-engage-configuration",
          component: () => import("./views/modules/crm/Engage/Configuration/EngageConfiguration.vue"),
          meta: {
            requiresAuth: true,
            permission: "vp.crm.engageconfiguration.view",
            menu: 4
          }
        },

        {
          path: "/crm/engage/configuration/email/:id",
          name: "crm-engage-configuration-email",
          component: () => import("./views/modules/crm/Engage/Configuration/Email/Email.vue"),
          meta: {
            requiresAuth: true,
            menu: 4
          }
        },




      ]
    },

    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: "",
      component: () => import("@/layouts/full-page/FullPage.vue"),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: "/auth-redirect",
          name: "auth-redirect",
          component: () => import("@/views/pages/AuthRedirect.vue")
        },
        {
          path: "/login",
          name: "login",
          component: () => import("@/views/pages/AutoLogin.vue")
        },
        {
          path: "/pages/error-404",
          name: "page-error-404",
          component: () => import("@/views/pages/Error404.vue")
        },
        {
          path: "/pages/no-access",
          name: "page-no-access",
          component: () => import("@/views/pages/NoAccess.vue")
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/pages/error-404"
    }
  ]
});

router.beforeEach((to, from, next) => {
  // No auth required
  if (!to.matched.some(record => record.meta.requiresAuth)) {
    next();
    return;
  }

  // Authenticated
  const requiresIdamAuth = to.matched.some(record => record.meta.permission)
  const hasIdamPermission = !requiresIdamAuth || Vue.prototype.$AuthService.hasPermissionForActiveVenue(to.meta.permission)
  const accessToken = localStorage.getItem("rekom.life.accessToken");

  // /*&& router.app.$msal.isAuthenticated() === true*/
  if (accessToken !== null && hasIdamPermission) {
    store.commit("UPDATE_SELECTED_MENU", to.meta.menu);
    next();
    return;
  } else if (accessToken !== null && !hasIdamPermission) {

    // Retry once;
    if (!window.location.href.includes("redirected")) {
      // Reloads
      window.location.search += "&redirected"
      return;
    }

    next({ name: 'page-no-access' })
    return;
  }
});


router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
